module.exports = __webpack_public_path__ + "static/media/02 category @1x.fe8d5523.jpg";